import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import { getSportradarTeamId } from '~/utilities/elements/getSportradarTeamId';
import { useSportradarVerticalTopic } from '~/utilities/useSportradarVerticalTopic';
import SportradarFactory from '~/components/Shared/Sportradar/SportradarFactory';
import { AppDataContext } from '~/contexts/AppDataContext';
import type { LinkValueInterface } from '~/types/AppData/Layout/LinkValueInterface';

// Schedule widget used on post page templates
export default component$(
  ({ getVertical }: { getVertical: string }): JSX.Element => {
    const { payloadToSSR } = useContext(AppDataContext);
    const article = useContext(ArticleContext);

    if (!article) return <></>;

    let scheduleUrl = '';
    if (payloadToSSR.layout.subHeader?.links?.value) {
      const links = payloadToSSR.layout.subHeader.links.value;
      scheduleUrl =
        links.find((link: LinkValueInterface) => link.link.text === 'Schedule')
          ?.link.url ?? '';
    }

    const { vertical, topic } = useSportradarVerticalTopic();

    // Fansided has customVertical and customTopic in the article object,
    // SI has to derive this from the URL
    const widgets = getSportradarTeamId(
      getVertical === 'url' ? vertical : (article.customVertical as string),
      getVertical === 'url' ? topic : (article.customTopic as string)
    );

    // Don't show Sportradar if it's a finiteScroll article (only allowed on the first article)
    if (article.finiteScrollNumber && article.finiteScrollNumber > 0)
      return <></>;

    return widgets.map(
      (widget: { widgetId: string; teamId: string | number }, index) => {
        const { widgetId, teamId } = widget;
        if (widgetId.length == 8 || !teamId) return null;

        return (
          <SportradarFactory
            key={index}
            name={widgetId}
            sportradarProps={{
              teamUid: teamId,
            }}
            wrapperClass='my-10 mx-4 sportradarWrapper'
            position='sidebar'
            // TODO - Check if is SI once useIsSI is available
            buttonUrl={scheduleUrl}
            buttonTitle='Full Schedule'
          />
        );
      }
    );
  }
);
